<template>
    <div class="card-body pt-0">
        <div class="row mb-0 rooms-advanced-search">
            <div class="formdynamic__item col-md-2 py-0" v-if="show_inspection">
                <div class="formdynamic__item__field">
                    <label class="modal-label input-date-template" v-html="`Inspection:`"/>
                    <select class="input-field custom-select" v-model="form_data_filter.inspection_id">
                        <option value="" v-html="'Select an option'"/>
                        <option v-for="(value, i) in array_options.inspection_id" :key="i" :value="value.id" v-html="value.name"/>
                    </select>
                </div>
            </div>
            <div class="formdynamic__item col-md-2 py-0" v-if="show_view_inspections">
                <div class="formdynamic__item__field">
                    <label class="modal-label input-date-template" v-html="`View inspections:`"/>
                    <select class="input-field custom-select" v-model="form_data_filter.status">
                        <option v-for="(value, i) in statuses_options" :key="i" :value="value.id" v-html="value.name"/>
                    </select>
                </div>
            </div>
            <div class="formdynamic__item col-md-2 py-0">
                <div class="formdynamic__item__field">
                    <label class="modal-label input-date-template" v-html="`Inspection Type:`"/>
                    <select class="input-field custom-select" v-model="form_data_filter.inspection_type_id">
                        <option value="" v-html="'Select an option'"/>
                        <option v-for="(value, i) in array_options.inspection_type_id" :key="i" :value="value.id" v-html="value.name"/>
                    </select>
                </div>
            </div>
            <div class="formdynamic__item col-md-2 py-0">
                <div class="formdynamic__item__field">
                    <label class="modal-label input-date-template" v-html="`Supervisor:`"/>
                    <select class="input-field custom-select" v-model="form_data_filter.associate_id">
                        <option value="" v-html="'Select an option'"/>
                        <option v-for="(value, i) in array_options.associate_id" :key="i" :value="value.id" v-html="value.name"/>
                    </select>
                </div>
            </div>
            <div class="formdynamic__item col-md-2 py-0">
                <div class="formdynamic__item__field">
                    <label class="modal-label input-date-template" v-html="`Associate:`"/>
                    <select class="input-field custom-select" v-model="form_data_filter.associate_employee_id">
                        <option value="" v-html="'Select an option'"/>
                        <option v-for="(value, i) in array_options.employee_id" :key="i" :value="value.id" v-html="value.associate_name"/>
                    </select>
                </div>
            </div>
            <div class="formdynamic__item col-md-2 py-0">
                <div class="formdynamic__item__field">
                    <label class="modal-label input-date-template" v-html="`Date Range:`"/>
                    <date-range-picker
                        class="d-block"
                        ref="picker"
                        v-model="form_data_filter.date_range"
                        cancelLabel="Clear"
                    >
                    <template v-slot:input="picker" style="min-width: 350px;">
                        {{ date(picker.startDate) }} - {{ date(picker.endDate) }}
                    </template>

                    <div slot="footer" slot-scope="data" class="slot p-2">
                        <span class="d-inline-block" style="margin-left: 2px; font-size: 13px; min-width: 7.5rem;">
                           {{ data.rangeText }}
                        </span>
                        <span style="margin-left: auto">
                            <a @click="clearRangeDate(data)" class="modal__buttons__item cancel">Cancel</a>
                        </span>
                        <span style="margin-left: auto">
                            <a @click="data.clickApply" v-if="!data.in_selection" class="modal__buttons__item" style="width: 4.5rem">Apply</a>
                        </span>
                    </div>
                </date-range-picker>

                </div>
            </div>
            <div class="formdynamic__item col-md-2 py-0">
                <div class="formdynamic__item__field">
                    <label class="modal-label input-date-template" v-html="`Template:`"/>
                    <select class="input-field custom-select" v-model="form_data_filter.inspection_template_id">
                        <option value="" v-html="'Select an option'"/>
                        <option v-for="(value, i) in array_options.inspection_template_id" :key="i" :value="value.id" v-html="value.name"/>
                    </select>
                </div>
            </div>
            <div class="formdynamic__item col-md-2 py-0">
                <div class="formdynamic__item__field">
                    <label class="modal-label input-date-template" v-html="`Needs Correction:`"/>
                    <select class="input-field custom-select" v-model="form_data_filter.needs_correction">
                        <option value="" v-html="'Select an option'"/>
                        <option value="1" v-html="'Yes'"/>
                        <option value="0" v-html="'No'"/>
                    </select>
                </div>
            </div>
            <div class="formdynamic__item col-md-2 py-0">
                <div class="formdynamic__item__field">
                    <label for="Building:" class="modal-label" v-html="'Building:'"/>
                    <select size="" class="input-field custom-select" v-model="form_data_filter.building_id">
                        <option value="" v-html="'Select an option'"/>
                        <option v-for="(item, i) in array_options.building_id" :key="i" :value="item.id" v-html="item.name"/>
                    </select>
                </div>
            </div>
            <div class="formdynamic__item col-md-2 py-0">
                <div class="formdynamic__item__field">
                    <label for="Level:" class="modal-label" v-html="'Level:'"/>
                    <select size="" class="input-field custom-select" v-model="form_data_filter.level_id">
                        <option value="" v-html="'Select an option'"/>
                        <option v-for="(item, i) in array_options.level_id" :key="i" :value="item.id" v-html="item.name"/>
                    </select>
                </div>
            </div>
            <div class="formdynamic__item col-md-2 py-0">
                <div class="formdynamic__item__field">
                    <label for="Area:" class="modal-label" v-html="'Area:'"/>
                    <select size="" class="input-field custom-select" v-model="form_data_filter.area_id">
                        <option value="" v-html="'Select an option'"/>
                        <option v-for="(item, i) in array_options.area_id" :key="i" :value="item.id" v-html="item.name"/>
                    </select>
                </div>
            </div>
            <div class="formdynamic__item col-md-2 py-0">
                <div class="formdynamic__item__field">
                    <label for="Floor:" class="modal-label" v-html="'Floor:'"/>
                    <select size="" class="input-field custom-select" v-model="form_data_filter.floor_id">
                        <option value="" v-html="'Select an option'"/>
                        <option v-for="(item, i) in array_options.floor_id" :key="i" :value="item.id" v-html="item.name"/>
                    </select>
                </div>
            </div>
            <div class="formdynamic__item col-md-2 py-0">
                <div class="formdynamic__item__field">
                    <label for="Area:" class="modal-label" v-html="'Room:'"/>
                    <input size="" class="input-field" v-on:input="debounceInput({value: $event.target.value, field: 'room'})"/>
                </div>
            </div>
            <button type="button" class="modal__buttons__item mt-3" @click="applyFilters()">Apply Filters</button>
        </div>
    </div>
</template>
<script>

import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from 'moment'
import _ from 'lodash'

export default {
  name: "LocalFormFilter",

  components:{
    DateRangePicker,
  },

  props: [
    "array_options",
    "form_data_filter",
    "show_view_inspections",
    "show_inspection",
    "is_empty"
  ],

  data(){
    return{
        rest_api_search: 'rooms_advanced_search',
        statuses_options: [
            {
                id: '',
                name: 'All',
            },
            {
                id: true,
                name: 'Completed',
            },
            {
                id: false,
                name: 'Incomplete',
            },
        ],
    }
  },

  methods: {
    debounceInput:  _.debounce(function (e)  {
        this.form_data_filter[e.field] = e.value
    },800),

    clearRangeDate(data)
    {
        data.clickCancel()
        this.form_data_filter.date_range = { startDate: null, endDate: null }
    },

    date(val) 
    {
        return val ? moment(val).format("MM/D/YYYY") : "";
    },
    applyFilters()
    {
        this.$emit('getReport')
    }

  },
  watch: {
    async 'form_data_filter.building_id'(val)
    {
        this.form_data_filter.level_id = ''

        if(val)
        {
            let http_request = {
                id:             val,
                type_request:   'building',
            }

            const response = await this.get(`${this.rest_api_search}/${JSON.stringify(http_request)}`);
            if(response.status)
            {
                if(response.data.length)
                {
                    setTimeout(() => {
                        this.array_options.level_id = response.data
                    }, 300);
                    this.notyfMesg('Levels available for the selected building')
                }
                else
                {
                    this.array_options.level_id = []
                    this.notyfMesg('No levels available for the selected building', 'error')
                }
            }
            else
            {
                this.error_handling(response)
            }
        }
        else
        {
            this.array_options.level_id = []
        }
    },

    async 'form_data_filter.level_id'(val)
    {
        this.form_data_filter.area_id = ''

        if(val)
        {
            let http_request = {
                id:             val,
                type_request:   'level',
            }
            const response = await this.get(`${this.rest_api_search}/${JSON.stringify(http_request)}`);
            if(response.status)
            {
                if(response.data.length)
                {
                    setTimeout(() => {
                        this.array_options.area_id = response.data
                    }, 300);
                    this.notyfMesg('Areas available for the selected level')
                }
                else
                {
                    this.array_options.area_id = []
                    this.notyfMesg('No areas available for the selected level', 'error')
                }
            }
            else
            {
                this.error_handling(response)
            }
        }
        else
        {
            this.array_options.area_id = []
        }
    },
  }
}
</script>